export default __webpack_public_path__ + "static/polypack-9ba45995dac7dc9ebaa014f746351a68.png";